import React from 'react';
import cn from 'classnames';

import CheckboxTickIcon from '../../../assets/icons/common/forms/CheckboxTickIcon';

import styles from './styles.module.scss';

const Checkbox = ({
  className,
  label,
  checked,
  value,
  cypressAttr,
  ...props
}) => {
  const innerValue = checked || value;
  return (
    <label
      className={cn('text-s', styles.label, className)}
      data-cy={cypressAttr}
    >
      <input type="checkbox" checked={innerValue} {...props} />
      <div
        className={cn({ [styles.iconBox]: true, [styles.checked]: innerValue })}
      >
        <CheckboxTickIcon className={styles.tickIcon} />
      </div>
      {label}
    </label>
  );
};

export default Checkbox;
